import { createAsyncThunk } from "@reduxjs/toolkit";
import apiConfig from "constants/apiConfig";
import { fetchCollections, fetchCreatorsCollection, fetchPostCollection } from "services/api/collection";
import { AuthState } from "slices/auth/reducer";
import { ERROR } from "types";
import { CollectionsResponse, CollectionState, PostCollectionItem } from "types/collection";
import { generateUniqueKey, getErrorMessage, isFresh } from "utils/helpers";

export const fetchCollectionsThunk = createAsyncThunk<{response: CollectionsResponse, cached?: boolean}, {force?: boolean}, {rejectValue: string}>(
    'collections',
    async ({force = false}, {getState, rejectWithValue}) => {
        try {
            const state = getState() as {auth: AuthState, collections: CollectionState};
            const STALE_TIME = apiConfig.FETCH_COLLECTIONS.staleTime;
            const currentData = state.collections.list;
            if (!force && isFresh(state.collections?.last_fetched_at ?? null, STALE_TIME) && currentData) {
                return {response: currentData, cached: true}
            }
            const agencyId = state.auth.selectedAgencyId ?? '';
            if (!agencyId) throw new Error("No agency selected!");
            const response = await fetchCollections(agencyId);
            return {response, cached: false}
        } catch (error) {
            console.log('err', error)
            return rejectWithValue(getErrorMessage(error));
        }
    }
)

export const fetchPostCollectionItemsThunk = createAsyncThunk<{collectionId: string, items: PostCollectionItem[], filters: any, filterId: string, count: number}, {collectionId: string, filters: any, force?: boolean}, {rejectValue: string}>(
    'collection/post',
    async ({collectionId, filters, force=false}, {getState, rejectWithValue}) => {
        try {
            const state = getState() as {auth: AuthState, collections: CollectionState};
            const STALE_TIME = apiConfig.FETCH_POST_COLLECTION.staleTime;
            const filterId = generateUniqueKey(filters, ['page']);
            if (filters.page === 1 && !force && isFresh(state.collections?.collections[collectionId]?.data?.items?.filtered_lists?.[filterId]?.last_fetched_at ?? null, STALE_TIME)) {
                return rejectWithValue(ERROR.CACHED);
            }
            const agencyId = state.auth.selectedAgencyId ?? '';
            if (!agencyId) throw new Error("No agency selected!");
            const response = await fetchPostCollection(agencyId, filters, collectionId);
            return {items: response.items, filters, filterId, collectionId, count: response.count}
            
        } catch (error) {
            return rejectWithValue(getErrorMessage(error));
        }
    }
)

export const fetchCreatorsCollectionItemsThunk = createAsyncThunk<{collectionId: string, items: PostCollectionItem[], filters: any, filterId: string, count: number}, {collectionId: string, filters: any, force?: boolean}, {rejectValue: string}>(
    'collection/creators',
    async ({collectionId, filters, force=false}, {getState, rejectWithValue}) => {
        try {
            const state = getState() as {auth: AuthState, collections: CollectionState};
            const STALE_TIME = apiConfig.FETCH_POST_COLLECTION.staleTime;
            const filterId = generateUniqueKey(filters, ['page']);
            if (filters.page === 1 && !force && isFresh(state.collections?.collections[collectionId]?.data?.items?.filtered_lists?.[filterId]?.last_fetched_at ?? null, STALE_TIME)) {
                return rejectWithValue(ERROR.CACHED);
            }
            const agencyId = state.auth.selectedAgencyId ?? '';
            if (!agencyId) throw new Error("No agency selected!");
            const response = await fetchCreatorsCollection(agencyId, filters, collectionId);
            return {items: response.items, filters, filterId, collectionId, count: response.count}
            
        } catch (error) {
            return rejectWithValue(getErrorMessage(error));
        }
    }
)